import React, { useState } from 'react';
import styled from 'styled-components';
import { ActionButton } from 'styled_components/Common/ActionButton';
import { BloxButton } from 'styled_components/Common/BloxButton';
import { DailyTest } from 'styled_components/SVG/DailyTest';
import { DailySelector } from 'styled_components/SVG/DailySelector';
import { PieSelector } from 'styled_components/SVG/PieChart';
import { BarSelector } from 'styled_components/SVG/BarChart';
import { TrendSelector } from 'styled_components/SVG/TrendSelector';
import { Divider } from 'styled_components/Common/Divider';
import { ToggleButton } from 'styled_components/Common/ToggleButton';
import { IconButton } from 'styled_components/Common/IconButton';
import { CogSVG } from 'styled_components/SVG/CogSVG';
const theme1 = {
	account: '#416ba9',
	support: '#8060a9',
	storage: '#008388',
	billing: '#a8ad00',
	Cool_Gray_Med_1: '#a2a9ad',
	Cool_Gray_Light_3: '#edefef',
};
const ButtonsStyle = styled.div`
	@media screen and (min-width: ${props => props.theme.res.medium}) and (max-width: ${props =>
			props.theme.res.high}) {
	}
	@media screen and (min-width: ${props => props.theme.res.high}) {
	}
`;

function checkSliderPosition4(element) {
	let position4 = 'left';
	if (!element.classList[0].includes('1') && !element.classList[0].includes('2')) {
		if (element.classList[0].includes('2')) {
			position4 = 'right';
		} else if (element.classList[0].includes('3')) {
			position4 = 'right';
		} else if (element.classList[0].includes('0')) {
			position4 = 'left';
		}

		return position4;
	}
}
function clicky(id) {
	const element = document.getElementById(id);
	element.classList.toggle('active');
	document.getElementById(`${id}trans2`).beginElement();
	if (document.getElementById(`${id}trans3`)) {
		document.getElementById(`${id}trans3`).beginElement();
	}
}

function transitionImageOver(id) {
	const isIE = /*@cc_on!@*/ false || !!document.documentMode;
	// Edge 20+
	const isEdge = !isIE && !!window.StyleMedia;
	const windows = isIE || isEdge;
	if (windows) {
		document.getElementById('issue-request-component-wrapper').classList.add('windows');
	} else {
		document.getElementById(`${id}trans1`).beginElement();
	}
}

function checkSliderPosition(id) {
	const element = document.getElementById(id);
	let position = 'left';
	if (!element.classList[0].includes('1')) {
		if (element.classList[0].includes('2')) {
			position = 'right';
		} else if (element.classList[0].includes('3')) {
			position = 'right';
		} else if (element.classList[0].includes('0')) {
			position = 'left';
		}

		return position;
	}
}

export const Buttons = () => {
	const [toggle, setToggle] = useState('two');
	const [position, setPosition] = useState('left');
	return (
		<ButtonsStyle>
			<div className='component'>
				<Divider />
				<div className='component-title heading70'>Icon Buttons</div>
				<IconButton
					svgId='daily-selector-3'
					enabled={true}
					id='icon-button'
					module='storage'
					breakpoint={930}
				>
					<DailyTest
						id='daily-selector-3'
						module='storage'
						theme={theme1}
						position={position}
						className={'daily'}
					/>
				</IconButton>
				<br />
				<IconButton
					enabled={true}
					id='icon-button-2'
					module='storage'
					breakpoint={1344}
					svgId='daily-selector-3'
				>
					<DailyTest
						id='daily-selector-3'
						module='storage'
						theme={theme1}
						position={position}
						className={'daily'}
					/>
				</IconButton>
				<br />
				<IconButton
					svgId='daily-selector-3'
					enabled={true}
					id='icon-button-3'
					module='storage'
					breakpoint={2240}
				>
					<DailyTest
						id='daily-selector-3'
						module='storage'
						theme={theme1}
						position={position}
						className={'daily'}
					/>
				</IconButton>
			</div>
			<div>
				{toggle === 'two' && (
					<ToggleButton module='storage' id='toggle-slider' theme={theme1} groupName='togglers-1'>
						<BarSelector id='bar-selector-1' module='storage' theme={theme1} className={'bar'} />
						<PieSelector id='pie-selector-1' module='storage' theme={theme1} className={'pie'} />
					</ToggleButton>
				)}
				{toggle === 'three' && (
					<ToggleButton
						module='storage'
						id='toggle-slider-2'
						theme={theme1}
						groupName='togglers-2'
						checkSlider={() => setPosition(checkSliderPosition('toggle-slider-2'))}
					>
						<BarSelector id='bar-selector-2' module='storage' theme={theme1} className={'bar-2'} />
						<DailySelector
							id='daily-selector-1'
							module='storage'
							theme={theme1}
							position={position}
							className={'daily'}
						/>
						<PieSelector id='pie-selector-2' module='storage' theme={theme1} className={'pie-2'} />
					</ToggleButton>
				)}
				{toggle === 'four' && (
					<ToggleButton
						module='storage'
						id='toggle-slider-3'
						theme={theme1}
						groupName='togglers-3'
						checkSlider={() => setPosition(checkSliderPosition4('toggle-slider-3'))}
					>
						<BarSelector id='bar-selector-3' module='storage' theme={theme1} className={'bar-3'} />
						<DailySelector
							id='daily-selector-2'
							module='storage'
							theme={theme1}
							position={position}
							className={'daily-2'}
						/>
						<TrendSelector
							id='trend-selector-1'
							module='storage'
							theme={theme1}
							position={position}
							className={'trend'}
						/>
						<PieSelector id='pie-selector-3' module='storage' theme={theme1} className='pie-3' />
					</ToggleButton>
				)}
			</div>
			<div className='buttons'>
				<ActionButton
					id='special-id-1'
					onClick={() => clicky('special-id-1')}
					onMouseOver={() => transitionImageOver('special-id-1')}
					module='support'
				>
					<CogSVG id='special-id-1' />
				</ActionButton>
				<BloxButton
					id='button-5'
					text='TENLETTERS'
					module='storage'
					enabled={true}
					className='buttons41'
				/>

				<BloxButton
					text='12 LTR/SPACE'
					module='billing'
					enabled={true}
					id='button-6'
					className='buttons41'
				/>
				<BloxButton
					text='1414 LTR/SPACE'
					module='account'
					enabled={true}
					id='button-7'
					className='buttons41'
				/>
				<BloxButton
					text='Show Toggle 2'
					module='support'
					enabled={true}
					id='button-1216'
					className='buttons41'
					onClick={() => setToggle('two')}
				/>
				<BloxButton
					text='Show Toggle 3'
					module='support'
					enabled={true}
					id='button-1214'
					className='buttons41'
					onClick={() => setToggle('three')}
				/>
				<BloxButton
					text='Show Toggle 4'
					module='support'
					enabled={true}
					id='button-1213'
					className='buttons41'
					onClick={() => setToggle('four')}
				/>
			</div>
		</ButtonsStyle>
	);
};
